export * from "./indexReact";

declare global {
  interface Window {
    plasma: {
      environment: Record<string, unknown>;
    }
  }
}
